import { useState } from "react";
import styled from "styled-components";
import Feature1Box from "./Feature1Box";
import {
  SubtitleHolder,
  SubtitleText,
  TitleHolder,
  TitleText,
} from "./Features1.styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../../locales/localeSlice";

interface StyledDivProps {
  isHovered: boolean;
}

export const Feature1ContainerBox = styled.div<StyledDivProps>`
  width: 605px;
  height: 500px;
  flex-shrink: 0;
  border-radius: 30px;
  position: relative;
  background-color: ${(props) => (props.isHovered ? "#EBF3FF" : "#ccd7e8")};

  @media screen and (max-width: 1920px) {
    margin-left: 590px;
  }

  @media screen and (max-width: 1440px) {
    width: 605px;
    height: 500px;
    margin-left: 90px;
  }

  @media screen and (max-width: 1024px) {
    width: 519px;
    height: 451px;
    margin-left: 730px;
  }
  @media screen and (max-width: 768px) {
    width: 519px;
    height: 451px;
    margin-left: 930px;
  }

  @media screen and (max-width: 430px) {
    width: 350px;
    margin-left: 500px;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
    margin-left: 420px;
  }
  @media screen and (max-width: 320px) {
    width: 300px;
    margin-left: 380px;
  }
`;

export const Feature1SmallBox = styled.div<StyledDivProps>`
  width: 454px;
  height: 290px;
  flex-shrink: 0;
  border-radius: 30px;
  /* border: 2px solid red; */
  position: absolute;
  background-color: ${(props) => (props.isHovered ? "#B9C8DF" : "white")};
  box-shadow: 0px 94px 100px 0px rgba(204, 215, 232, 0.49);
  z-index: 11;
  display: flex;
  justify-content: center;
  transition:
    top 1s ease,
    transform 1s ease-in-out;
  transition: background-color 0.3s ease;
  left: 70px;
  top: ${(props) => (props.isHovered ? "380px" : "400px")};

  @media screen and (max-width: 1440px) {
    width: 454px;
    height: 290px;
  }
  @media screen and (max-width: 1024px) {
  }

  @media screen and (max-width: 1024px) {
    width: 360px;
    height: 290px;
    left: 70px;
    top: ${(props) => (props.isHovered ? "310px" : "330px")};
  }
  @media screen and (max-width: 768px) {
    width: 360px;
    height: 290px;
    left: 70px;
    top: ${(props) => (props.isHovered ? "310px" : "330px")};
  }

  @media screen and (max-width: 430px) {
    width: 250px;
    height: 229px;
    left: 49px;
  }
  @media screen and (max-width: 375px) {
    width: 245px;
    height: 229px;
    left: 39px;
    top: ${(props) => (props.isHovered ? "330px" : "350px")};
  }
  @media screen and (max-width: 320px) {
    width: 235px;
    height: 229px;
    left: 33px;
    top: ${(props) => (props.isHovered ? "330px" : "350px")};
  }
`;

const Features1 = () => {
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);

  const handleHover = () => {
    setIsHovered(true);
  };

  const handleLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <Feature1ContainerBox
        isHovered={isHovered}
        onMouseEnter={handleHover}
        onMouseLeave={handleLeave}
      >
        <TitleHolder>
          <TitleText>
            {t("amazingFeatures.cardOne.titleText1", { lng: currentLocale })}
            <br />
            {t("amazingFeatures.cardOne.titleText2", { lng: currentLocale })}
          </TitleText>
        </TitleHolder>
        <SubtitleHolder>
          <SubtitleText>
            {t("amazingFeatures.cardOne.subTextLineOne", {
              lng: currentLocale,
            })}
            {t("amazingFeatures.cardOne.subTextLineTwo", {
              lng: currentLocale,
            })}
          </SubtitleText>
        </SubtitleHolder>
        <Feature1SmallBox
          isHovered={isHovered}
          onMouseEnter={handleHover}
          onMouseLeave={handleLeave}
        >
          <Feature1Box />
        </Feature1SmallBox>
      </Feature1ContainerBox>
    </>
  );
};

export default Features1;
